import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=56022dbf&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"
import style0 from "./Full.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports